'use client'
import React, { useContext } from 'react'
import styles from '@shared/components/Advertisement/HomePage.module.scss'
import arror from '@assets/images/Advertisement/circle_arrow.svg'
import cb from '@assets/images/Advertisement/cb.png'
import cbDark from '@assets/images/Advertisement/darkModeImages/cbDark.png'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'
import FeatureCard from '@shared/components/Advertisement/FeatureCard/FeatureCard'
import ProductFeature from '@shared/components/Advertisement/ProductFeature/ProductFeature'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

const HomePage = () => {
  const { stateGlobalEvents } = useContext(GlobalEventsContext)
  return (
      <>
        <div
          className="d-flex align-items-center justify-content-between ps-5 py-5"
          style={{
            backgroundImage:
              'radial-gradient(at right, rgba(255, 124, 79, 0.4) 12.38%, rgba(255, 124, 79, 0) 58%)'
          }}
        >
          <div className="d-flex flex-column home_content">
            <h1 className={styles.H1}>
              Grow your Business with <br />
              <span className={styles.textOrange}>One</span>{' '}
              <span className={styles.textBlue}>Turf</span>
              <span className={styles.text}>News</span>
            </h1>
            <p className={styles.para}>
              Make your business shine online with a custom advertising website
              designed just for you by a professional designer. Need ideas? Get
              inspired and start planning the perfect advertising web design
              today.
            </p>
            <CustomLink
              href="#plancard"
              >
              <div className={`d-flex align-items-center gap-2 ${styles.divBtn}`}
              >
             See Plans
             <MyImage src={arror} alt="Arrow" className="btn-icon" />
             </div>
            </CustomLink>
          </div>
          <div className={`${styles.cbImg} d-md-block d-none`}>
          {
            stateGlobalEvents?.darkModeEna === 'dark' ? <MyImage src={cbDark} alt="Laptop" width={971} height={614} /> : <MyImage src={cb} alt="Laptop" width={971} height={614} />
          }
          </div>
        </div>
        <FeatureCard />
        <ProductFeature />
      </>
  )
}

export default HomePage
